import { inUse, isProduct, type MaterialRow } from "./meta";

/** How names and item numbers are compared: trimmed, any case (a name by its first line: its tags' lines aside). */
const key = (s: string) => s.split("\n")[0]?.trim().toLowerCase() ?? "";

/**
 * Archived ones (not in use) of this kind with the name or item number being typed: restoring one keeps its history (its jobs and
 * sales, by its uuid) together, where a new one would start again beside it. Item number matches first.
 */
export function archivedMatches(materials: readonly MaterialRow[], product: boolean, name: string, itemNumber: string): MaterialRow[] {
    const [n, num] = [key(name), key(itemNumber)];
    if (!n && !num) return [];
    const archived = materials.filter((m) => !inUse(m) && isProduct(m) === product);
    const byNumber = num ? archived.filter((m) => key(m.item_number) === num) : [];
    const byName = n ? archived.filter((m) => key(m.name) === n && !byNumber.includes(m)) : [];
    return [...byNumber, ...byName];
}
